import { Stat } from "../types";
import { ServiceInteractions } from "@vviinn/user-managment-client-ts/dist/models/ServiceInteractions";

export const prepareCommonStats = (
  interaction: ServiceInteractions,
): Stat[] => {
  return [
    {
      name: "Result views",
      primaryStat: interaction.resultViews ?? 0,
    },
    {
      name: "Product clicks",
      primaryStat: interaction.productClicks ?? 0,
    },
    {
      name: "Clickthrough rate (CTR)",
      primaryStat: interaction.clickThroughRate
        ? Math.round(interaction.clickThroughRate * 10000) / 100
        : 0,
      addPercentage: true,
    },
  ];
};
